"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminErrorBoundary = void 0;
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
/**
 * Error boundary component to catch exceptions in react components and display
 * a fallback UI.
 */
class AdminErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.resetErrorBoundary = () => {
            this.setState({ hasError: false });
        };
        this.state = { hasError: false };
    }
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({ hasError: true });
        console.log('An exception occurred in a react component', error, info);
    }
    render() {
        if (this.state.hasError) {
            // Go to error page as fallback UI
            return react_1.default.createElement("div", null, this.props.t('admin:UnknownError'));
        }
        return this.props.children;
    }
}
exports.AdminErrorBoundary = AdminErrorBoundary;
exports.default = (0, react_i18next_1.withTranslation)('admin')(AdminErrorBoundary);
//# sourceMappingURL=AdminErrorBoundary.js.map